var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCommentUser = function SvgIconCommentUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 47,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconCommentUser_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24 19.583a5.875 5.875 0 1 1 0-11.75 5.875 5.875 0 0 1 0 11.75m-5.938 10.28a6.233 6.233 0 0 1 11.874 0 1.96 1.96 0 0 0 3.795-.98c-2.567-9.687-16.9-9.683-19.46 0a1.957 1.957 0 1 0 3.791.98m5.956 16.481a3.94 3.94 0 0 1-2.62-.997l-7.34-6.18H8.333A7.833 7.833 0 0 1 .5 31.333v-23.5A7.833 7.833 0 0 1 8.333 0h31.334A7.833 7.833 0 0 1 47.5 7.833v23.5a7.833 7.833 0 0 1-7.833 7.834H34.08l-7.534 6.227a3.8 3.8 0 0 1-2.528.95M8.333 3.917a3.917 3.917 0 0 0-3.916 3.916v23.5a3.917 3.917 0 0 0 3.916 3.917h6.441c.462 0 .908.163 1.261.46l7.924 6.678 8.17-6.69c.351-.29.792-.448 1.248-.448h6.29a3.916 3.916 0 0 0 3.916-3.917v-23.5a3.917 3.917 0 0 0-3.916-3.916z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconCommentUser_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h47v47H.5z"
  })))));
};
export default SvgIconCommentUser;